// extracted by mini-css-extract-plugin
export default {"screenContainer":"styles_screenContainer__-z+fN"};